/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputEwFrequencyRange } from './OutputEwFrequencyRange';
import {
    OutputEwFrequencyRangeFromJSON,
    OutputEwFrequencyRangeFromJSONTyped,
    OutputEwFrequencyRangeToJSON,
} from './OutputEwFrequencyRange';

/**
 * 
 * @export
 * @interface OutputEwSuppressionSession
 */
export interface OutputEwSuppressionSession {
    /**
     * 
     * @type {string}
     * @memberof OutputEwSuppressionSession
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputEwSuppressionSession
     */
    createdBy?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputEwSuppressionSession
     */
    createdByName?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputEwSuppressionSession
     */
    directionName?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputEwSuppressionSession
     */
    durationMinutes?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputEwSuppressionSession
     */
    endedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputEwSuppressionSession
     */
    expectedEndAt?: string;
    /**
     * 
     * @type {Array<OutputEwFrequencyRange>}
     * @memberof OutputEwSuppressionSession
     */
    frequencyRanges?: Array<OutputEwFrequencyRange>;
    /**
     * 
     * @type {number}
     * @memberof OutputEwSuppressionSession
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputEwSuppressionSession
     */
    scheduledAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputEwSuppressionSession
     */
    startedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputEwSuppressionSession
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputEwSuppressionSession
     */
    zoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputEwSuppressionSession
     */
    zoneName?: string;
}

/**
 * Check if a given object implements the OutputEwSuppressionSession interface.
 */
export function instanceOfOutputEwSuppressionSession(value: object): boolean {
    return true;
}

export function OutputEwSuppressionSessionFromJSON(json: any): OutputEwSuppressionSession {
    return OutputEwSuppressionSessionFromJSONTyped(json, false);
}

export function OutputEwSuppressionSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputEwSuppressionSession {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdByName': json['createdByName'] == null ? undefined : json['createdByName'],
        'directionName': json['directionName'] == null ? undefined : json['directionName'],
        'durationMinutes': json['durationMinutes'] == null ? undefined : json['durationMinutes'],
        'endedAt': json['endedAt'] == null ? undefined : json['endedAt'],
        'expectedEndAt': json['expectedEndAt'] == null ? undefined : json['expectedEndAt'],
        'frequencyRanges': json['frequencyRanges'] == null ? undefined : ((json['frequencyRanges'] as Array<any>).map(OutputEwFrequencyRangeFromJSON)),
        'id': json['id'] == null ? undefined : json['id'],
        'scheduledAt': json['scheduledAt'] == null ? undefined : json['scheduledAt'],
        'startedAt': json['startedAt'] == null ? undefined : json['startedAt'],
        'status': json['status'] == null ? undefined : json['status'],
        'zoneId': json['zoneId'] == null ? undefined : json['zoneId'],
        'zoneName': json['zoneName'] == null ? undefined : json['zoneName'],
    };
}

export function OutputEwSuppressionSessionToJSON(value?: OutputEwSuppressionSession | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'createdAt': value['createdAt'],
        'createdBy': value['createdBy'],
        'createdByName': value['createdByName'],
        'directionName': value['directionName'],
        'durationMinutes': value['durationMinutes'],
        'endedAt': value['endedAt'],
        'expectedEndAt': value['expectedEndAt'],
        'frequencyRanges': value['frequencyRanges'] == null ? undefined : ((value['frequencyRanges'] as Array<any>).map(OutputEwFrequencyRangeToJSON)),
        'id': value['id'],
        'scheduledAt': value['scheduledAt'],
        'startedAt': value['startedAt'],
        'status': value['status'],
        'zoneId': value['zoneId'],
        'zoneName': value['zoneName'],
    };
}

